import { useConnector } from "@solana/connector/react";
import { Base58Util } from "@solomon-labs/base58";
import { useCallback } from "react";

import { useSolomonE2ESigner } from "../e2e";
import { signVerificationMessage, type WalletMessageProof } from "../signVerificationMessage";

/** Keep ownership proofs separate from ConnectorKit's signature-only transaction signer. */
export function useWalletMessageSigner(): (address: string, message: string) => Promise<WalletMessageProof> {
    const { selectedWallet } = useConnector();
    const e2eSigner = useSolomonE2ESigner();
    return useCallback(
        async (address: string, message: string): Promise<WalletMessageProof> => {
            if (e2eSigner) {
                if (e2eSigner.address !== address) throw new Error("Wallet account changed before message signing");
                return { signature: Base58Util.encode(await e2eSigner.signMessage(new TextEncoder().encode(message))) };
            }
            if (!selectedWallet) throw new Error("Wallet not connected");
            return signVerificationMessage(selectedWallet, address, message);
        },
        [selectedWallet, e2eSigner]
    );
}
